type BaseProcuredOffer = {
  rooms: { leadInOffers: { id: string }[] }[];
};

const getLeadInOfferIds = (procuredOffer: BaseProcuredOffer) => {
  if (!procuredOffer) {
    return null;
  }

  return procuredOffer.rooms.flatMap((room) =>
    room.leadInOffers.map((leadInOffer) => leadInOffer.id),
  );
};

export default getLeadInOfferIds;
